import { render } from "./all-kompetensi.vue?vue&type=template&id=3b7edc2b&scoped=true"
import script from "./all-kompetensi.vue?vue&type=script&lang=js"
export * from "./all-kompetensi.vue?vue&type=script&lang=js"

import "./all-kompetensi.vue?vue&type=style&index=0&id=3b7edc2b&lang=css"
import "./all-kompetensi.vue?vue&type=style&index=1&id=3b7edc2b&scoped=true&lang=css"

import exportComponent from "/home/gitlab-runner/builds/WwEazHb5/0/pln-pusdiklat/ups/assessment_hc_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b7edc2b"]])

export default __exports__